/* Listicle-Tracking: sagt, welcher CTA klickt, wie weit gelesen wird und
   welche Einwaende geoeffnet werden. Ohne das laesst sich die Seite nicht
   optimieren, die data-listicle-cta-Attribute lagen bisher ungenutzt herum.
   Events landen im dataLayer (GTM) und, falls vorhanden, als fbq trackCustom. */
(function () {
  var listicle = window.location.pathname;
  window.dataLayer = window.dataLayer || [];

  function push(event, data, toMeta) {
    var payload = { event: event, listicle: listicle };
    for (var key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) payload[key] = data[key];
    }
    window.dataLayer.push(payload);
    // Nur der Klick geht zusaetzlich an Meta. View und Scrolltiefe wuerden das
    // Konto mit Custom Events fluten, ohne dass sie dort optimierbar waeren.
    if (toMeta && typeof window.fbq === 'function') {
      window.fbq('trackCustom', event, payload);
    }
  }

  push('listicle_view', {});

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var target = event.target.closest('[data-listicle-cta]');
    if (target) {
      push('listicle_cta_click', { cta_position: target.getAttribute('data-listicle-cta') }, true);
      return;
    }
    // Links im Fliesstext: der Rich-Text-Editor entfernt data-Attribute, daher
    // gibt der ref-Parameter der URL die Position an.
    var inline = event.target.closest('.rte a[href*="/products/"]');
    if (!inline) return;
    var ref = new URL(inline.href, window.location.href).searchParams.get('ref');
    push('listicle_cta_click', { cta_position: ref || 'text-link' }, true);
  });

  // Welche Frage geoeffnet wird, ist das ehrlichste Signal fuer den echten Einwand.
  document.addEventListener(
    'toggle',
    function (event) {
      var item = event.target;
      if (!item.matches || !item.matches('.listicle-faq__item') || !item.open) return;
      var question = item.querySelector('.listicle-faq__question span');
      push('listicle_faq_open', { question: question ? question.textContent.trim() : '' });
    },
    true
  );

  var marks = [25, 50, 75, 100];
  var reached = {};

  function onScroll() {
    var scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable <= 0) return;
    var percent = (window.scrollY / scrollable) * 100;
    for (var i = 0; i < marks.length; i += 1) {
      if (percent >= marks[i] && !reached[marks[i]]) {
        reached[marks[i]] = true;
        push('listicle_scroll', { depth: marks[i] });
      }
    }
    if (reached[100]) window.removeEventListener('scroll', onScroll);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
